import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=2a8ebfac&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=2a8ebfac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ebfac",
  null
  
)

export default component.exports